import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetConsorsNotesByLeadId } from 'cpool-tables/backend-resolvers';

import { useAggregateQuery } from '~/queryUtils/useQuery';

/**
 * Route-agnostic variant of `useGetConsorsNotesByLeadId`. The lead-details version is bound to the
 * leads-details route via `getRouteApi`; this version takes the subscriptionIdentifier as a prop so
 * it can be used outside the lead-details route (e.g. inside the notifications popover in the header).
 */
export const useConsorsNotesByLead = (loanRequestId: string, subscriptionIdentifier: string) => {
    return useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getConsorsNotesByLeadId,
        schema: schemaLoanRequestResolver_GetConsorsNotesByLeadId,
        searchParams: { id: loanRequestId, subscriptionIdentifier },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
